import React, { createContext, useContext, useEffect } from 'react';

// project-import
import { showToast } from '../components/sweet-alert/Sweetalert';
import {
    checkSignIn,
    checkUsername,
    forgotPass,
    postData,
    resetPass,
    signIn,
    signOut,
    signUp,
    updateData
} from './salesforce_api_context';
import {
    GET_LOGIN_BEGIN,
    GET_LOGIN_FAILURE,
    GET_LOGIN_STATUS_BEGIN,
    GET_LOGIN_STATUS_FAILURE,
    GET_LOGIN_STATUS_SUCCESS,
    GET_LOGIN_SUCCESS,
    GET_SIGNOUT_BEGIN,
    GET_SIGNOUT_FAILURE,
    GET_SIGNOUT_SUCCESS,
    GET_SIGNUP_BEGIN,
    GET_SIGNUP_FAILURE,
    GET_SIGNUP_SUCCESS,
    POST_FORGOT_PASSWORD_BEGIN,
    POST_FORGOT_PASSWORD_FAILURE,
    POST_FORGOT_PASSWORD_SUCCESS,
    POST_RESET_PASSWORD_BEGIN,
    POST_RESET_PASSWORD_FAILURE,
    POST_RESET_PASSWORD_SUCCESS,
    CHECK_USERNAME_AVAILABILITY_BEGIN,
    CHECK_USERNAME_AVAILABILITY_SUCCESS,
    CHECK_USERNAME_AVAILABILITY_FAILURE,
    UPDATE_USER_PROFILE_BEGIN,
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_FAILURE
} from '../constants/actions';
import { useBugContext } from './bug_context';

// third-party
import { useDispatch, useSelector } from 'react-redux';

// Create context
export const UserContext = createContext();

export const UserProvider = (props) => {

    // Reading store data
    const state = useSelector(item => item.user);
    const { bugReportApi } = useBugContext();

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant functions

    // Function to handle signIn or login user
    const handleSignIn = async (payload) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_LOGIN_BEGIN, payload: true });

            // Calling API to signIn user or login user 
            let signInData = await signIn(payload);

            // Dispatching the actions on success
            dispatch({ type: GET_LOGIN_SUCCESS, payload: signInData });

            // Showing the toast message on login successfully
            // showToast("success", "Logged in successfully", true, "bottom-right", false, true, 5000);
            return signInData;
        } catch (error) {
            console.log("54 : user_context : Error while login :: ", error && JSON.stringify(error));
            // const response = error?.response;
            // if (response?.data.statusCode === 500) {
            //     dispatch({ type: GET_LOGIN_FAILURE, payload: response?.data.message });
            //     showToast('error', response && response?.message ? response?.data.message : 'Please try again later.', true, "bottom-right", false, true, 5000);
            // } 
            // else {
            //     dispatch({ type: GET_LOGIN_FAILURE, payload: response?.data.message });
            //     showToast('error', response && response?.data.message ? response?.data.message : 'Please try again later.', true, "bottom-right", false, true, 5000);
            // }
            const status = error?.response?.status;
            if (status === 404) {
                dispatch({ type: GET_LOGIN_FAILURE, payload: error?.response?.data?.message });
                showToast('error', "Account Not Found. We couldn’t find an account with this email address or username. Please register to continue.", true, "bottom-right", false, true, 5000);
            }
            else if (status === 401) {
                dispatch({ type: GET_LOGIN_FAILURE, payload: error?.response?.data?.message })
                showToast('error', "The password you entered is incorrect. Kindly try again.", true, "bottom-right", false, true, 5000);
            } else {
                dispatch({ type: GET_LOGIN_FAILURE, payload: error?.message });
                showToast('error', "Please try again later.", true, "bottom-right", false, true, 5000);
            }
            
            bugReportApi("Error while signIn : Login", `/api/user/login`, "POST", error);
        }
    }

    // Function to handle signUp or register
    const handleSignUp = async (payload) => {

        try {
            delete payload["confirmPassword"];
            // Dispatchin the action to begin the api calling process
            dispatch({ type: GET_SIGNUP_BEGIN, payload: true });

            // Calling Api to signUp or register user
            let response = await signUp(payload);

            // Disptaching the actions on success
            dispatch({ type: GET_SIGNUP_SUCCESS, payload: response });

            // Showing the toast message on signUp successfully
            showToast("success", "Your account has been created.", true, "bottom-right", false, true, 5000);

            return response ? response : "";

        } catch (error) {
            console.log("84 : user_context : Error while signing up::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_SIGNUP_FAILURE, payload: error.message });

            bugReportApi("Error while signUp : Register", `/api/user/register`, "POST", error);

            // Showing the toast message on signUp unsuccessfully
            showToast("error", error && error.message ? error.message : "Please try again later", true, "bottom-right", false, true, 5000);
        }
    }

    // Function to handle signOut
    const handleSignOut = async () => {
        try {
            // dispatching the action to begin  the api calling process
            dispatch({ type: GET_SIGNOUT_BEGIN, payload: true });

            // Calling API to signOut user
            // let signOutData = [];
            let signOutData = await signOut({});
            // let signOutData = await postData("/api/user/logout");

            // dispatching the actions on success
            dispatch({ type: GET_SIGNOUT_SUCCESS, payload: signOutData });

            // Showing the toast message on signOut successfully
            showToast("success", "You have been logged out successfully.", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("109 : user_context : Error while signing out::", error && JSON.stringify(error));

            // dispatching the actions on error
            dispatch({ type: GET_SIGNOUT_FAILURE, payload: error && error.message });

            bugReportApi("Error while sign out", `/api/user/logout`, "POST", error);

            // Showing the toast message on signOut unsuccessfully
            showToast("error", error && error.message ? "You are unable to sign out at this moment. Please try again later!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    // Function to check login Status
    const checkLoginstatus = async () => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_LOGIN_STATUS_BEGIN, payload: true });

            // Calling API to signIn user or login user 
            let signInData = await checkSignIn("/api/user/check-login-status");

            // Dispatching the actions on success
            dispatch({ type: GET_LOGIN_STATUS_SUCCESS, payload: signInData });

            return signInData;
        } catch (error) {
            console.log("54 : user_context : Error while check login status :: ", error && JSON.stringify(error));
            dispatch({ type: GET_LOGIN_STATUS_FAILURE, payload: error && error.message, });
            bugReportApi("Error while check login status", "/api/user/check-login-status", "GET", error);
        }
    }

    // Function to forgot password
    const handleFogotPass = async (payload) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: POST_FORGOT_PASSWORD_BEGIN, payload: true });

            // Calling API to signIn user or login user 
            let response = await forgotPass("/api/user/forgot-password", payload);

            // Dispatching the actions on success
            dispatch({ type: POST_FORGOT_PASSWORD_SUCCESS, payload: response });

            // Showing the toast message on login successfully
            showToast("success", "We have sent you a password reset link. Please check your email!", true, "bottom-right", false, true, 5000);
            return response;
        } catch (error) {
            console.log("54 : user_context : Error while forgot password :: ", error && JSON.stringify(error));
            dispatch({ type: POST_FORGOT_PASSWORD_FAILURE, payload: error && error.message, });
            bugReportApi("Error while forgot password API calling", "/api/user/forgot-password", "POST", error);
            showToast("error", error && error.message ? error.message : "Please try again later", true, "bottom-right", false, true, 5000);
        }
    }

    // Function to Reset password
    const handleResetPass = async (payload) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: POST_RESET_PASSWORD_BEGIN, payload: true });

            // Calling API to signIn user or login user 
            let response = await resetPass("/api/user/reset-password", payload);

            // Dispatching the actions on success
            dispatch({ type: POST_RESET_PASSWORD_SUCCESS, payload: response });

            // Showing the toast message on login successfully
            // showToast("success", "Logged in successfully", true, "bottom-right", false, true, 5000);
            return response;
        } catch (error) {
            console.log("54 : user_context : Error while reset password :: ", error && JSON.stringify(error));
            dispatch({ type: POST_RESET_PASSWORD_FAILURE, payload: error && error.message, });
            bugReportApi("Error while reset password API calling", "/api/user/reset-password", "POST", error);
        }
    }

    // Function to checkusername availability
    const checkUsernameAvailability = async (payload) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: CHECK_USERNAME_AVAILABILITY_BEGIN, payload: true });

            // Calling API to signIn user or login user 
            let response = await checkUsername(`/api/check-username-availability?userName=${payload}`);

            // Dispatching the actions on success
            dispatch({ type: CHECK_USERNAME_AVAILABILITY_SUCCESS, payload: response });

            return response;
        } catch (error) {
            console.log("54 : user_context : Error while CHECK USERNAME AVAILABILITY :: ", error && JSON.stringify(error));
            dispatch({ type: CHECK_USERNAME_AVAILABILITY_FAILURE, payload: error && error.message, });
            bugReportApi("Error while check username availability API", `/api/check-username-availability?userName=${payload}`, "GET", error);
        }
    }

    // Function to handle update User Profile
    const updateUserProfile = async (id, payload) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: UPDATE_USER_PROFILE_BEGIN, payload: true });

            // Calling API to update user-profile
            let response = await updateData(`/api/user/update-profile/${id}`, payload);

            // Dispatching the actions on success
            dispatch({ type: UPDATE_USER_PROFILE_SUCCESS, payload: response });

            // Showing the toast message on update user-profile successfully
            showToast(
                "success",
                "Profile picture updated successfully!",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
            return response;
        } catch (error) {
            console.log("54 : user_context : Error while update user-profile :: ", error && JSON.stringify(error));
            showToast("error", "Error while Uploading Profile Image.Please try again later", true, "bottom-right", false, true, 5000);
            dispatch({ type: UPDATE_USER_PROFILE_FAILURE, payload: error?.response?.data?.message });
            bugReportApi("Error while update user profile", `/api/user/update-profile/${id}`, "PUT", error);
        }
    }
    useEffect(() => {
        if (state && state?.loginData?.data) {
            checkLoginstatus();
        }
    }, []);

    return (
        <UserContext.Provider value={{ ...state, handleSignIn, handleSignUp, handleSignOut, handleFogotPass, handleResetPass, checkUsernameAvailability, updateUserProfile }}>
            {props.children}
        </UserContext.Provider>
    )
}


export const useUserContext = () => {
    return useContext(UserContext);
}
